var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(_vm.currentVersion, {
    ref: "dashboard",
    tag: "component",
    attrs: {
      profile: _vm.profile,
      user: _vm.user,
      labels: _vm.labels,
      values: _vm.values,
      loadingUser: _vm.loadingUser,
      loadingProfile: _vm.loadingProfile,
      numberOfDecimal: _vm.numberOfDecimal
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }